/**
Copyright 2021 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
export const LOAD_TRAININGS = "LOAD_TRAININGS";
export const UPDATE_LOTYPES_FILTERS = "UPDATE_LOTYPES_FILTERS";
export const UPDATE_LEARNERSTATE_FILTERS = "UPDATE_LEARNERSTATE_FILTERS";
export const UPDATE_SKILLNAME_FILTERS = "UPDATE_SKILLNAME_FILTERS";
export const UPDATE_SKILLLEVEL_FILTERS = "UPDATE_SKILLLEVEL_FILTERS";
export const UPDATE_LOFORMAT_FILTERS = "UPDATE_LOFORMAT_FILTERS";
export const UPDATE_TAGS_FILTERS = "UPDATE_TAGS_FILTERS";
export const UPDATE_DURATION_FILTERS = "UPDATE_DURATION_FILTERS";
export const UPDATE_CATALOGS_FILTERS = "UPDATE_CATALOGS_FILTERS";
export const UPDATE_PRICE_FILTERS = "UPDATE_PRICE_FILTERS";
export const UPDATE_CITIES_FILTERS = "UPDATE_CITIES_FILTERS";
export const UPDATE_FILTERS_ON_LOAD = "UPDATE_FILTERS_ON_LOAD";
export const PAGINATE_TRAININGS = "PAGINATE_TRAININGS";
export const UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT";
export const RESET_SEARCH_TEXT = "RESET_SEARCH_TEXT";
export const UPDATE_SNIPPET_TYPE = "UPDATE_SNIPPET_TYPE";
export const UPDATE_SNIPPET_ON_LOAD = "UPDATE_SNIPPET_ON_LOAD";
export const OPEN_SNIPPET_TYPE_DIALOG = "OPEN_SNIPPET_TYPE_DIALOG";
export const CLOSE_SNIPPET_TYPE_DIALOG = "CLOSE_SNIPPET_TYPE_DIALOG";
